import React,{useState,useEffect} from "react";
import { useDispatch } from "react-redux";

import anim_line from "../../img/winter.png"
import { createCourseByAdmin, createCourseByAdminV2 } from "../../../store/actions/CreateCourse/createCourseByAdmin"; 
import { getAllCourseThumbnails } from "../../../store/actions/CreateCourse/getAllCourseThumbnails"; 

import somethingwentwrong from "../../img/somethingwentwrong.png"
import { useParams ,useHistory, useRouteMatch,} from "react-router-dom";

import Loading from "../../Loading/Loading";
import { useSelector } from "react-redux";
import {X,Plus ,Star,BookmarkPlus, HopIcon} from 'lucide-react';

import Snackbar from "../../../Snackbar";
import UploadImgToWP from "../../Create/UploadImgToWP";
import NextStepCardPopUp from "../AppCards/NextStepCardPopUp";
import AppMenuCardBlueBG from "../AppCards/AppMenuCardBlueBG";
import ImageWithFallback from "../../UI/ImageFallBack";
import UploaderAllCM from "../../Create/CreateContent/Uploader/UploaderAllCM";


const AddThumbnailProduct = ({setActiveCardOverview,baseUrl})=>{
  const {courseId} = useParams();
//   const {url}=useRouteMatch();
  const history = useHistory();
 const dispatch = useDispatch();  
 const [snackbarVisible, setSnackbarVisible] = useState(false);
 
 const [snackbarColor, setSnackbarColor] = useState("#958FDA");
 const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
 const showSnackbar = () => {
  setSnackbarVisible(true);
};

 const hideSnackbar = () => {
  setSnackbarVisible(false);
};
const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
  {
    
    dispatch({type: "CURSOR",payload:true  });

    dispatch({type: "CURSORTEXT",payload:CursorText})
    dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
    dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
  }
   
  const handleMouseLeave = () => {
    
    dispatch({type: "CURSOR",payload:false})

    dispatch({type: "CURSORTEXT",payload:""})

    dispatch({type: "CURSORTEXTBG",payload:""})
    dispatch({type: "CURSORTEXTCOLOR",payload:""})
  

}
 const token = useSelector((state)=>state?.course?.course?.token);
 const currentToken = useSelector((state)=>state?.user?.user?.token);
 const user_email = useSelector((state)=>state?.user?.user?.user_email
);

const postIdCourse = useSelector((state)=>state?.course?.course?.postId);

const courseData = useSelector((state)=>state?.course?.course);

 
 const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
 const appId = useSelector((state)=>state?.app?.app?.ID);
 const appAllottedToken = useSelector((state)=>state?.app?.app?.appAllottedToken);
 
  const [loader , setLoader] =useState({status:false});
  const [productID, setProductID] = useState(courseData?.ID?courseData?.ID:"");
  const [editType, setEditType] = useState(courseData?.ID?"thumbnails":"");
 const thumbnails =courseData?.thumbnails?(courseData?.thumbnails):[]; 
const [openPopUp ,setOpenPopUp]  = useState(false)
 const [imagesJson, setImagesJson] = useState([])
 
   const [goNextPopUp, setGoNextPopUp] =useState(false);
 const [animate, setAnimate] = useState(false); 
 const [selectedImg , setSelectedImg] =useState(courseData?.thumbnails?courseData?.thumbnails?.file?.file:"")
  const [openUploaderPopUp, setOpenUploaderPopUp] = useState(false);
         const [currentFileType, setCurrentFileType] = useState({});
       const [currentFileObject,setCurrentFileObject] = useState({}); 
          const [currentFile,setCurrentFile] = useState(""); 
           
        const [thumbnail, setThumbnail] = useState("");
             

useEffect(()=>{
  setActiveCardOverview(true);
  
  // setCourseTitleData();
},[])
 useEffect(() => {
   // Trigger the animation after a delay (e.g., 500ms)
   const timer = setTimeout(() => {
    setAnimate(true);  
  }, 100);

   return () => clearTimeout(timer); // Cleanup on unmount
 }, []);

 







    
    
      const handleCreateProduct=(thumbnailKey)=>{
      
      
      
      setLoader({status:true});
      
        const apiData = dispatch(createCourseByAdminV2({thumbnails:thumbnailKey,type:courseData?.ID?courseData?.type:"course",
          postParent:"0" ,userEmail:user_email?user_email:"",
          currentToken:currentToken?currentToken:"",
          editType:editType,postId:productID,appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}));
        /* get response as Promise   */
        apiData.then(response => {
          if(response){
            if(response?.course){
              
          setResponseMessage(response?.message);
          setSnackbarColor("rgba(144, 202, 249,1)");
        
           
      setLoader({status:false});
      
      setSnackbarVisible(true);
      setTimeout(()=>{
        
        setSnackbarVisible(false);
        setSelectedImg(response?.course?.thumbnails);
        setProductID(response?.course?.postId);
       setEditType("thumbnails")
       setGoNextPopUp(true);
      },1000)
         }else{
          setResponseMessage("Something Went Wrong...");
            
          setSnackbarColor("#958FDA");
       
           
      setLoader({status:false});
      
      setSnackbarVisible(true);
      setTimeout(()=>{
        
        setSnackbarVisible(false);
       
         
      },3000)
         }
            
         
         if(response?.logout){
         
          setResponseMessage("You are Logged Out!!!");
            
          setSnackbarColor("#958FDA");
       
           
      setLoader({status:false});
      
      setSnackbarVisible(true);
      setTimeout(()=>{
        
        setSnackbarVisible(false);
       
         
      },3000)
          setTimeout(()=>{
            dispatch({type:"LOGOUT"});
      
          },3000)
          
        }
      /* resetting Login input Fields */
      
          }else{
            setResponseMessage("Something Went Wrong...");
            
            setSnackbarColor("#958FDA");
         
             
        setLoader({status:false});
        
        setSnackbarVisible(true);
        setTimeout(()=>{
          
          setSnackbarVisible(false);
         
           
        },3000)    }
      
        }).catch(error => {
       
          //popup of error Info
          setResponseMessage("Something Went Wrong...");
            
          setSnackbarColor("#958FDA");
       
           
      setLoader({status:false});
      
      setSnackbarVisible(true);
      setTimeout(()=>{
        
        setSnackbarVisible(false);
       
         
      },3000)
          console.error(error);
        });
       
        }
        
    return <>
    
{<>

{<Loading  Load={loader?.status}/>}
{snackbarVisible && (
        <Snackbar message={responseMessage} color={snackbarColor}  onClose={hideSnackbar} />
      )}
<div  className="ikcraft_login-signup-card-outerj"><div  className="CreateCourseStepsOuter contentPageScroller" style={{background:"#fff",borderRadius:"25px"}}>
<div  className="CreateCourseStepsOuterLeft"style={{height:"280px",
        transform: animate ? 'scale(1)' : 'scale(.9)',marginTop:"20px",
        opacity: animate ? 1 : 0,
        transition: 'transform 2s ease, opacity 1s ease',
      }}>
<div className="anim_line">
          
<span><img src={anim_line} alt="anim_line"/></span>
<span><img src={anim_line} alt="anim_line"/></span>
<span><img src={anim_line} alt="anim_line"/></span>
           </div>
           <HopIcon size={60}   color="#958FDA" /> 
    <div style={{padding:"10px",float:'left'}}className="create-card-title">
   Step: 1.1</div>

   <h1 style={{"textAlign":"center",
        transform: animate ? 'translateY(0)' : 'translateY(50px)',
        opacity: animate ? 1 : 0,
        transition: 'transform 1s ease, opacity 1s ease',
      }}>   Let`s Add An Attractive <span className="coloredTextV1"
       >Thumbnail</span> To Lure Your Students</h1>
     
<div className="coloredTextV1"  style={{width:"200px",display:"flex",justifyContent:"center",position:"relative",zIndex:99
     }}> 
      
      
  <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} onClick={()=>{ setOpenUploaderPopUp(true);;setCurrentFileType({ title: "Image", value: "image" })}} style={{width:"40px",height:"40px",cursor:"pointer",
        borderRadius:"50%",margin:"5px",marginLeft:"100px",marginBottom:"20px",
      background:"#958FDA"}} > <Plus  style={{margin:"9px"}}  color="#ffffff" size={22}/></div>
      </div>:
</div>
<div className="">

 <div className="" style={{display:"flex",justifyContent:"space-around",background:"rgba(144, 202, 249,0.2)",borderRadius:"10px",marginTop:"10px",marginLeft:"10px",marginRight:"10px",marginBottom:"10px",paddingLeft:"10px",paddingTop:"5px",paddingBottom:"5px",paddingBottom:"5px"}}> 
        <div style={{"textAlign":"center",
     top: animate ? '0px' : '20px',position:"relative",
     opacity: animate ? 1 : 0.5,
     transition: 'top 1s ease, opacity 1s ease',
   marginTop:"0px"}}>  <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} style={{marginTop:"15px",fontSize:"25px",padding:"10px",}}>Add Image </div>
    {selectedImg?<ImageWithFallback src={selectedImg} widthOuter={"170px"} fireOpenEdit ={()=>{setOpenUploaderPopUp(true);;setCurrentFileType({ title: "Image", value: "image" })}}  iconSize={28} setOpenFullImg={()=>{setOpenUploaderPopUp(true);;setCurrentFileType({ title: "Image", value: "image" })}}/>:
            <ImageWithFallback src={""} widthOuter={"170px"} fireOpenEdit ={()=>{setOpenUploaderPopUp(true);;setCurrentFileType({ title: "Image", value: "image" })}}  iconSize={28} setOpenFullImg={()=>{setOpenUploaderPopUp(true);;setCurrentFileType({ title: "Image", value: "image" })}}/>}
   </div> 
   
   
   
    <div style={{"textAlign":"center",
     top: animate ? '0px' : '-20px',position:"relative",
     opacity: animate ? 1 : 0.5,
     transition: 'top 1s ease, opacity 1s ease',
   marginTop:"0px",display:"flex",justifyContent:"center",alignItems:"center",}} >
    <button onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave} onClick={()=>{setOpenUploaderPopUp(true);;setCurrentFileType({ title: "Image", value: "image" })}}   className=" CoursesPreviewTopBtn"  type="submit"
   > Upload Image </button>
   </div>
   </div>
 {openUploaderPopUp && (
           <UploaderAllCM
             fileTypeObject={[currentFileType]}
            selectedFileObject={currentFileObject} currentFileObject={currentFileObject} setCurrentFileObject={(v)=>{setCurrentFileObject(v);
               setThumbnail(v?.file_s3_key);setSelectedImg(v?.fileUrl)
               handleCreateProduct(v?.file_s3_key)
               
            }}
             setCloseUploaderPopUp={() => setOpenUploaderPopUp(false)}
           />
         )} 
   {goNextPopUp?<NextStepCardPopUp loadingText="Going Next..."  title="Next Step> Add  Demo Videos .   Let's Go Next" type="addAproxContent"
 closePopUp={()=>{setGoNextPopUp(false)}}
 onClickPopup={(type)=>{setTimeout(()=>{
  history.push(`${baseUrl}/demo-videos`)
 },1000)
  }}/>:""}
 
  <div className="gridForWhatsNextAfterYT5"style={{
        transform: animate ?  'translateY(0)' : 'translateY(50px)',
        opacity: animate ? 1 : 0,
        transition: 'transform 2s ease, opacity 1s ease',
      }}>
   
   <AppMenuCardBlueBG activeCard={""} icon={1} title ="Add Contents " onClickPopup={
          ()=>{ history.push(`${baseUrl}/approx-material`)
          }}  />
          <AppMenuCardBlueBG  activeCard={""} icon={5} title ="Add Thumbnail " onClickPopup={
            ()=>{ history.push(`${baseUrl}/thumbnails`) 
            }}  /><AppMenuCardBlueBG activeCard={""} icon={4} title ="Add Demo Videos " onClickPopup={
              ()=>{  history.push(`${baseUrl}/demo-videos`)
              }}  /><AppMenuCardBlueBG activeCard={""} icon={7} title ="Next Phase " onClickPopup={
                ()=>{  history.push(`${baseUrl}/labels`) 
                }}  />
   
   </div>
</div>

</div>
  <div className="CreateCourseStepsOuterBottom" style={{padding:'15px',fontSize:'12px',marginBottom:'10px'}}>
    <div  >   </div>
  
    
    <button onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  className="CreateCourseStepsOuterRightButtonBack"  type="submit"
     id="signupBtn"> Back </button>
 
 <button onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  className="CreateCourseStepsOuterRightButton"  type="submit"
     id="signupBtn"> Save And Next </button>
  </div></div>
</>}
    </>

}
export default AddThumbnailProduct;